import { Fit, Layout, type Rive, useRive } from "@rive-app/react-canvas";
import { type ComponentProps, useEffect } from "react";

type CustomRiveProps = {
  src: string;
  autoplay?: boolean;
  fit?: Fit;
  stateMachines?: string[];
  onLoad?: () => void;
  onRiveInit?: (rive: Rive | null) => void;
} & ComponentProps<"canvas">;

export const CustomRive = ({
  src,
  autoplay = true,
  fit = Fit.Contain,
  stateMachines,
  onLoad,
  onRiveInit,
  ...props
}: CustomRiveProps) => {
  const { RiveComponent, rive } = useRive({
    src,
    autoplay,
    stateMachines,
    layout: new Layout({ fit }),
    onLoad: () => {
      rive?.resizeDrawingSurfaceToCanvas();
      onLoad?.();
    },
  });

  // Pass rive instance to consumer
  useEffect(() => {
    onRiveInit?.(rive);
  }, [rive, onRiveInit]);

  return <RiveComponent {...props} />;
};
